/*
Monotype Foundry Platform API
Version 1.0.0

Definition: BannedWordsLogs

Properties:
  module: string (required)
  fieldName: string (required)
  bannedWords: array (required)
  foundryId: string (required)
*/

var BannedWordsLogs = (function () {
  function validateBannedWordsLogs (arg) {
    // Validate module
    if (!arg.module) {
      throw new Error('BannedWordsLogs.module: Missing property')
    }
    if (arg.module && !(typeof arg.module === 'string')) {
      throw new Error('BannedWordsLogs.module: Wrong type: Got \'' + (typeof arg.module) + '\', but expected: \'string\'')
    }
    // Validate fieldName
    if (!arg.fieldName) {
      throw new Error('BannedWordsLogs.fieldName: Missing property')
    }
    if (arg.fieldName && !(typeof arg.fieldName === 'string')) {
      throw new Error('BannedWordsLogs.fieldName: Wrong type: Got \'' + (typeof arg.fieldName) + '\', but expected: \'string\'')
    }
    // Validate bannedWords
    if (!arg.bannedWords) {
      throw new Error('BannedWordsLogs.bannedWords: Missing property')
    }
    if (arg.bannedWords && !(Array.isArray(arg.bannedWords))) {
      throw new Error('BannedWordsLogs.bannedWords: Wrong type: Got \'' + (typeof arg.bannedWords) + '\', but expected: \'array\'')
    }
    // Validate foundryId
    if (!arg.foundryId) {
      throw new Error('BannedWordsLogs.foundryId: Missing property')
    }
    if (arg.foundryId && !(typeof arg.foundryId === 'string')) {
      throw new Error('BannedWordsLogs.foundryId: Wrong type: Got \'' + (typeof arg.foundryId) + '\', but expected: \'string\'')
    }
  }
  function buildBannedWordsLogs (arg) {
    var BannedWordsLogs = arg
    // Complete module
    // Expected Type: string
    BannedWordsLogs.module = BannedWordsLogs.module || ''
    // Complete fieldName
    // Expected Type: string
    BannedWordsLogs.fieldName = BannedWordsLogs.fieldName || ''
    // Complete bannedWords
    // Expected Type: array
    BannedWordsLogs.bannedWords = BannedWordsLogs.bannedWords || []
    // Complete foundryId
    // Expected Type: string
    BannedWordsLogs.foundryId = BannedWordsLogs.foundryId || ''
    return BannedWordsLogs
  }
  return {
    validate: validateBannedWordsLogs,
    build: buildBannedWordsLogs
  }
})()

module.exports = BannedWordsLogs
